(function () {
  const header = document.querySelector('.header-wrapper');
  if (!header) return;

  let lastScrollY = window.scrollY;
  let ticking = false;

  window.addEventListener('scroll', function () {
    if (!ticking) {
      window.requestAnimationFrame(function () {
        const currentScrollY = window.scrollY;

        if (currentScrollY < 60) {
          header.classList.remove('nav-hidden');
        } else if (currentScrollY > lastScrollY) {
          header.classList.add('nav-hidden');
        } else {
          header.classList.remove('nav-hidden');
        }

        lastScrollY = currentScrollY;
        ticking = false;
      });
      ticking = true;
    }
  }, { passive: true });
})();

